import React from 'react';
import { Row, Column } from 'mage-components';
import styled from 'styled-components';
import { CardComponent } from '@/components';
import { ErrorAlert } from '@/components/ErrorAlert';
import { ErrorMessage } from '@/components/ErrorMessage';
export const CardsSelector = ({ value, onChange, options = [], error, showErrorOnTop, }) => {
    const isSelected = (currentValue) => currentValue === value;
    return (React.createElement(React.Fragment, null,
        showErrorOnTop && error ? (React.createElement(StyledWrapper, null,
            React.createElement(ErrorAlert, { error: error }))) : null,
        React.createElement(Row, null, Object.values(options).map(option => (React.createElement(Column, { columns: { desktop: 6, mobile: 12 }, key: option.key },
            React.createElement(CardComponent, { error: !showErrorOnTop && error, id: option.key, isSelectedFn: isSelected, onChange: onChange, enumTranslationFunction: enumTranslationFunction(option) }))))),
        !showErrorOnTop && error ? React.createElement(ErrorMessage, { message: error }) : null));
};
const StyledWrapper = styled.div.withConfig({ displayName: "StyledWrapper", componentId: "sc-akbxee" }) `
  position: fixed;
  bottom: auto;
  z-index: 99;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
  border-radius: 1em;
`;
const enumTranslationFunction = (option) => (t, key) => {
    /**
     * TODO: What to do with these defaults (?)
     */
    const DEFAULT_LABEL = `products-fe.options.business_concepts.${key}.label`;
    const DEFAULT_DESCRIPTION = `products-fe.options.business_concepts.${key}.description`;
    return {
        title: t(option.label || DEFAULT_LABEL) || option.fallbackLabel,
        description: t(option.description || DEFAULT_DESCRIPTION) || option.fallbackDescription,
    };
};
